import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment-timezone';
import { apiCall, disableForm, enableForm, getBaseDir, float2moeda, moeda2float } from '../../utils';
import Swal from 'sweetalert2';
const {jsPDF} = window.jspdf

var financialCategoryAndCostCenterDataRef = null;
var financialSupplierDataRef = null;
var selectedBills = [];

// Função auxiliar para calcular o valor total
let currentBillData = {
  VALOR: 0,
  VALOR_BASE: 0
};

const calculateTotal = (isEdit = false) => {
  const prefix = ''+isEdit+'_';
  
  // Obter valores dos campos
  let baseValue = moeda2float($(`#${prefix}btp_expense_base_value`).val()) || 0;
  let penalty = moeda2float($(`#${prefix}btp_expense_penalty`).val()) || 0;
  let discount = moeda2float($(`#${prefix}btp_expense_discount`).val()) || 0;

  //console.log('Valores iniciais:', { baseValue, penalty, discount });

  if (isNaN(baseValue)) {
    baseValue = 0;
  }
  if (isNaN(penalty)) {
    penalty = 0;
  }
  if (isNaN(discount)) {
    discount = 0;
  }

  //console.log('baseValue', typeof baseValue);
  //console.log('penalty', typeof penalty);
  //console.log('discount', typeof discount)

  // Calcular total
  let total = Number(baseValue) + Number(penalty) - Number(discount);

  //console.log('Total calculado:', total);

  // Atualizar o campo de valor total (readonly)
  $(`#${prefix}btp_expense_value`).val(float2moeda(total));

  return total;
};

// Detecta alteração no valor base original
$(document).on('keyup', '#insert_btp_expense_base_value, #edit_btp_expense_base_value', function() {
  const type = $(this).data('type');
  let value = moeda2float($(this).val());
  console.log('base value', value);
  if (!isNaN(value)) {
      currentBillData.VALOR_BASE = value;
      //$(this).val(float2moeda(value));
  }
  
  calculateTotal(type);
});

// Detecta alteração no valor da multa
$(document).on('keyup', '#insert_btp_expense_penalty, #edit_btp_expense_penalty', function() {
  const type = $(this).data('type');
  let value = moeda2float($(this).val());
  console.log('penalty value', value);
  if (!isNaN(value)) {
      if (value < 0) value = 0;
      //$(this).val(float2moeda(value));
  }
  
  calculateTotal(type);
});

// Detecta alteração no valor do desconto
$(document).on('keyup', '#insert_btp_expense_discount, #edit_btp_expense_discount', function() {
  const type = $(this).data('type');
  let value = moeda2float($(this).val());
  console.log('discount value', value);
  
  if (!isNaN(value)) {
      if (value < 0) value = 0;
      //$(this).val(float2moeda(value));
  }
  
  calculateTotal(type);
});

// Função para inicializar os campos
const initializeFields = (isEdit = false, billData = null) => {
  const prefix = isEdit ? 'edit_' : 'insert_';
  
  if (isEdit && billData) {
      // Em modo de edição, calcular o valor base
      const totalValue = (billData.VALOR) || 0;
      const penalty = (billData.VALOR_MULTA) || 0;
      const discount = (billData.VALOR_DESCONTO) || 0;

      /*console.log('totalValue', totalValue);
      console.log('penalty', penalty);
      console.log('discount', discount);*/
      
      // Valor base = valor total - multa + desconto
      const baseValue = parseFloat(totalValue) - parseFloat(penalty) + parseFloat(discount);
      
      // Atualizar currentBillData
      currentBillData = {
          VALOR: totalValue,
          VALOR_BASE: baseValue
      };

      /*console.log('currentBillData', currentBillData);
      console.log('baseValue', float2moeda(baseValue));
      console.log('penalty', float2moeda(penalty));
      console.log('discount', float2moeda(discount));
      console.log('totalValue', float2moeda(totalValue));*/
      
      // Preencher os campos
      $(`#${prefix}btp_expense_base_value`).val(float2moeda(baseValue));
      $(`#${prefix}btp_expense_penalty`).val(float2moeda(penalty));
      $(`#${prefix}btp_expense_discount`).val(float2moeda(discount));
      $(`#${prefix}btp_expense_value`).val(float2moeda(totalValue));
  } else {
      // Modo inserção - inicializar com zeros
      currentBillData = {
          VALOR: 0,
          VALOR_BASE: 0
      };
      
      $(`#${prefix}btp_expense_base_value`).val('0,00');
      $(`#${prefix}btp_expense_penalty`).val('0,00');
      $(`#${prefix}btp_expense_discount`).val('0,00');
      $(`#${prefix}btp_expense_value`).val('0,00');
  }
  
  // Tornar o campo de valor total readonly
  $(`#${prefix}btp_expense_value`).prop('readonly', true);
};



// Seleciona a categoria financeira
$('#insert_btp_expense_category').select2({
  placeholder: "Selecione uma categoria financeira",
  theme: 'bootstrap-5',
  dropdownParent: $(".js-financial-bills-to-pay-insert-form-expense-category"),
  minimumInputLength: 0,
  ajax: {
    url: getBaseDir() + 'api/v1/financial/categories',
    delay: 1000,
    data: function(params) {
      var query = {
        search: params.term,
        branchId: localStorage.getItem('outerBTPSelectedBranch') || -1,
        page: params.page || 1,
        type: 'EXPENSE'
      }
      // Query parameters will be ?search=[term]&page=[page]
      return query;
    },
    processResults: function(data, params) {
      params.page = params.page || 1;

      var results = [];
      $.each(data.results, function(k, v) {
        results.push({
          id: v.ID,
          text: v.NOME,
          info: v
        });
      });

      // Transforms the top-level key of the response object from 'items' to 'results'
      return {
        results: results,
        pagination: {
          more: (params.page * 10) < data.count_filtered
        }
      };
    }
  }
});

// Detecta alteração na seleção da categoria financeira
$('#insert_btp_expense_category').on('select2:select', function(e) {
  if (e.params) {
    financialCategoryAndCostCenterDataRef = e.params.data.id;
  }
});

// Seleciona a categoria financeira
$('#insert_btp_expense_cost_center').select2({
  placeholder: "Selecione um centro de custo",
  theme: 'bootstrap-5',
  dropdownParent: $(".js-financial-bills-to-pay-insert-form-expense-cost-center"),
  minimumInputLength: 0,
  ajax: {
    url: getBaseDir() + 'api/v1/financial/cost-centers',
    delay: 1000,
    data: function(params) {
      var query = {
        search: params.term,
        branchId: localStorage.getItem('outerBTPSelectedBranch') || -1,
        page: params.page || 1
      }
      // Query parameters will be ?search=[term]&page=[page]
      return query;
    },
    processResults: function(data, params) {
      params.page = params.page || 1;

      var results = [];
      $.each(data.results, function(k, v) {
        results.push({
          id: v.ID,
          text: `${v.CODIGO} - ${v.NOME}`,
          info: v
        });
      });

      // Transforms the top-level key of the response object from 'items' to 'results'
      return {
        results: results,
        pagination: {
          more: (params.page * 10) < data.count_filtered
        }
      };
    }
  }
});

// Detecta alteração na seleção do centro de custo
$('#insert_btp_expense_cost_center').on('select2:select', function(e) {
  if (e.params) {
    financialCategoryAndCostCenterDataRef = e.params.data.id;
  }
});

// Seleciona a categoria financeira
$('#insert_btp_expense_supplier').select2({
  placeholder: "Selecione um fornecedor",
  theme: 'bootstrap-5',
  dropdownParent: $(".js-financial-bills-to-pay-insert-form-expense-supplier"),
  minimumInputLength: 0,
  ajax: {
    url: getBaseDir() + 'api/v1/financial/suppliers',
    delay: 1000,
    data: function(params) {
      var query = {
        search: params.term,
        branchId: localStorage.getItem('outerBTPSelectedBranch') || -1,
        page: params.page || 1
      }
      // Query parameters will be ?search=[term]&page=[page]
      return query;
    },
    processResults: function(data, params) {
      params.page = params.page || 1;

      var results = [];
      $.each(data.data, function(k, v) {
        results.push({
          id: v.ID,
          text: v.NOME,
          info: v
        });
      });

      // Transforms the top-level key of the response object from 'items' to 'results'
      return {
        results: results,
        pagination: {
          more: (params.page * 10) < data.count_filtered
        }
      };
    }
  }
});

// Detecta alteração na seleção da categoria financeira
$('#insert_btp_expense_supplier').on('select2:select', function(e) {
  if (e.params) {
    financialSupplierDataRef = e.params.data.id;
  }
});

$(document).on('submit', '.js-financial-bills-to-pay-insert-form', function(e) {
  e.preventDefault();

  let data = new FormData(this);
  let selfForm = this;

  $('.js-financial-bills-to-pay-insert-form').find('input[type="submit"]').prop('disabled', true);
  $('.js-financial-bills-to-pay-insert-form').find('input[type="submit"]').html('<i className="fa fa-spinner fa-spin"></i> Aguarde...');

  disableForm('.js-financial-bills-to-pay-insert-form');

  apiCall({
    method: 'POST',
    endpoint: 'api/v1/financial/bills-to-pay/create',
    data: data,
    processData: false,
    contentType: false,
    successCallback: (response) => {
      //console.log('response', response)
      $(selfForm).find('input[type="submit"]').prop('disabled', false);
      $(selfForm).find('input[type="submit"]').html('Cadastrar');
      $(selfForm).trigger('reset');

      window.toast({
        error: response.error,
        text: response.message
      })

      if (!response.error) {
        if (window.fetchBillsToPay) {
          window.fetchBillsToPay();
        }
        $('#insert_btp_expense_category').val('').trigger('change');
        $('#insert_btp_expense_supplier').val('').trigger('change');
        $('#modal-financial-insert-bills-to-pay').modal('hide');
      }
      enableForm('.js-financial-bills-to-pay-insert-form');
    },
    errorCallback: (error) => {
      console.error('error', error)
      $(selfForm).find('input[type="submit"]').prop('disabled', false);
      $(selfForm).find('input[type="submit"]').html('Cadastrar');
      enableForm('.js-financial-bills-to-pay-insert-form');
    }
  });
});


const BillsToPay = () => {

  const [branches, setBusinessBranches] = useState([]);
  const [branch, setBranch] = useState(null);
  const selectedBranch = useRef(null);

  var rangeStartDate = moment().startOf('month'),
      rangeEndDate = moment().endOf('month');

  const filterData = useRef({
    startDate: rangeStartDate.format('YYYY-MM-DD 00:00:00.000'),
    endDate: rangeEndDate.format('YYYY-MM-DD 23:59:59.000')
  })
  const paymentDateFilter = useRef({
    paymentDateStartDate: rangeStartDate.format('YYYY-MM-DD 00:00:00.000'),
    paymentDateEndDate: rangeEndDate.format('YYYY-MM-DD 23:59:59.000')
  })
    const interval = useRef(null);

  const [statusFilter, setStatusFilter] = useState('all');

  const countTotalBillsPaymentOpen = useRef(0);
  const countBillsOpen = useRef(0);

  const countTotalBillsPaymentPaid = useRef(0);
  const countBillsPaid = useRef(0);

  const countTotalBillsPaymentLate = useRef(0);
  const countBillsLate = useRef(0);

  const countTotalBillsPaymentPrevision = useRef(0);
  const countBillsPrevision = useRef(0);

  const [billsData, setBillsData] = useState([]);
  const [bills, setBills] = useState({
    countTotalBillsPaymentOpen: 0,
    countBillsOpen: 0,
    countTotalBillsPaymentPaid: 0,
    countBillsPaid: 0,
    countTotalBillsPaymentLate: 0,
    countBillsLate: 0,
    countTotalBillsPaymentPrevision: 0,
    countBillsPrevision: 0
  });

  const financialCategoryAndCostCenterDataRef = useRef(null);
  const financialSupplierDataRef = useRef(null);
  const financialBillEditData = useRef(null);
  
  const [multiBillSelectedData, setMultiBillSelectedData] = useState([]);

  const searchQueryTimeout = useRef(null);

  const currentXhr = useRef(null);

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    setBusinessBranches(userProfileResponse.businessBranches);
    clearInterval(interval.current);

    apiCall({
      method: 'GET',
      endpoint: 'api/v1/financial/expense-type',
      successCallback: function(res) {
        if (res.error) {
          window.toast({
              error: true,
              text: res.message
          })
        } else {
          let html = '<option selected default value="">-- Selecione --</option>';
          for(let i in res.data) {
            let expenseTypeObj = res.data[i];
            html += `<option value="${expenseTypeObj.ID}">${expenseTypeObj.NOME} (Fixa: ${expenseTypeObj.FIXA})</option>`
          }
          $('.js-financial-expenses-types').html(html);
        }
      },
      errorCallback: function() {
      }
    })
    
    $('.js-financial-bills-to-pay-daterange').daterangepicker({
      opens: 'left',
      startDate: rangeStartDate,
      endDate: rangeEndDate,
      opens: "right",
      drops: "down",
      locale: window._sessionData.i8nDateRangePicker, 
      ranges: {
        'Hoje': [moment().startOf('day'), moment().endOf('day')],
        'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Amanhã': [moment().add(1, 'days'), moment().add(1, 'days')],
        'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
        'Últimos 30 Dias': [moment().subtract(29, 'days'), moment()],
        'Este Mês': [moment().startOf('month'), moment().endOf('month')],
        'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
    }, function(start, end, label) {
        fetchBillsToPay(start.format('YYYY-MM-DD 00:00:00.000'), end.format('YYYY-MM-DD 23:59:59.000'));
    });

    $('.js-financial-bills-to-payment-date-daterange').daterangepicker({
      opens: 'left',
      startDate: rangeStartDate,
      endDate: rangeEndDate,
      opens: "right",
      drops: "down",
      locale: window._sessionData.i8nDateRangePicker, 
      ranges: {
        'Hoje': [moment().startOf('day'), moment().endOf('day')],
        'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Amanhã': [moment().add(1, 'days'), moment().add(1, 'days')],
        'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
        'Últimos 30 Dias': [moment().subtract(29, 'days'), moment()],
        'Este Mês': [moment().startOf('month'), moment().endOf('month')],
        'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
    }, function(start, end, label) {
        fetchBillsToPay(filterData.current.startDate, filterData.current.endDate, start.format('YYYY-MM-DD 00:00:00.000'), end.format('YYYY-MM-DD 23:59:59.000'));
    });

    $(document).on('change', '.js-leads-list-branches-selector', function() {
      selectedBranch.current = $(this).val();
      //outerBTPSelectedBranch = $(this).val();
      setBranch($(this).val());
      localStorage.setItem('outerBTPSelectedBranch', $(this).val());
      fetchBillsToPay();
    });

    // detecta busca de texto
    $(document).on('keyup', '.js-financial-bills-to-pay-search', function() {
      clearTimeout(searchQueryTimeout.current);
      searchQueryTimeout.current = setTimeout(function() {
        fetchBillsToPay();
      }, 1000);
    });

    $(document).on('click', '.js-financial-bills-to-pay-all-periods', function() {
      clearTimeout(searchQueryTimeout.current);
      searchQueryTimeout.current = setTimeout(function() {
        fetchBillsToPay();
      }, 1000);
    });

    $(document).on('click', '#filter_by_payment_date', function() {
      fetchBillsToPay();
    });

    // bind edit-form
    $(document).on('submit', '.js-financial-bills-to-pay-edit-form', function(e) {
      e.preventDefault();
      let formObj = this;

      if (financialBillEditData.current.RECORRENCIA_TIPO != null) {
        Swal.fire({
          title: 'ATENÇÃO!',
          text: 'Essa conta é um pagamento recorrente, deseja alterar todas parcelas futuras já lançadas pelo sistema?',
          icon: 'danger',
          showCancelButton: true,
          confirmButtonText: 'Sim, alterar todas parcelas ainda não pagas.',
          cancelButtonText: 'Não, alterar apenas esta.',
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6'
        }).then((result) => {
          if (result.isConfirmed) {
            updateBill(formObj, true)
          } else {
            updateBill(formObj)
          }
        });
      } else {
        updateBill(formObj, true)
      }
    });

    $(document).on('click', '.js-financial-btp-view-bill', function() {
      let bill = $(this).data('info');
      //console.log('js-financial-btp-view-bill', bill);
      $('#edit_btp_bill_id').val(bill.ID);
      $('#insert_btp_obs_bill_id').val(bill.ID);

      financialBillEditData.current = bill;
      financialCategoryAndCostCenterDataRef.current = null;

      if (bill.CATEGORIA !== null) {
        $('#edit_btp_expense_category').html(`<option value="${bill.CATEGORIA_ID}">${bill.CATEGORIA}</option>`);
        $('#edit_btp_expense_category').val(bill.CATEGORIA_ID).trigger('change');
        financialCategoryAndCostCenterDataRef.current = bill.CATEGORIA_ID;
      }

      if (bill.CENTRO_CUSTO !== null) {
        $('#edit_btp_expense_cost_center').html(`<option value="${bill.CENTRO_DE_CUSTO_ID}">${bill.CENTRO_CUSTO}</option>`);
        $('#edit_btp_expense_cost_center').val(bill.CENTRO_DE_CUSTO_ID).trigger('change');
        financialCategoryAndCostCenterDataRef.current = bill.CENTRO_DE_CUSTO_ID;
      }

      if (bill.FORNECEDOR !== null) {
        $('#edit_btp_expense_supplier').html(`<option value="${bill.FORNECEDOR_ID}">${bill.FORNECEDOR}</option>`);
        $('#edit_btp_expense_supplier').val(bill.FORNECEDOR_ID).trigger('change');
        financialCategoryAndCostCenterDataRef.current = bill.FORNECEDOR_ID;
      }

      $('#edit_btp_expense_type').val(bill.TIPO_DESPESA_ID);
      $('#edit_btp_expense_value').val(bill.VALOR);
      $('#edit_btp_expense_value').trigger('input');
      $('#edit_btp_expense_discount').val(bill.VALOR_DESCONTO);
      $('#edit_btp_expense_discount').trigger('input');
      $('#edit_btp_expense_penalty').val(bill.VALOR_MULTA);
      $('#edit_btp_expense_penalty').trigger('input');
      $('#edit_btp_expense_description').val(bill.DESCRICAO);
      $('#edit_btp_due_date').val(bill.DATA_VENCIMENTO?.split(" ")[0]);
      $('#edit_btp_paid_date').val(bill.DATA_PAGAMENTO?.split(" ")[0]);
      $('#edit_btp_is_paid').val(bill.PAGO);
      $('#edit_btp_recurrency_day').val(bill.RECORRENCIA_TIPO);
      $('#edit_btp_recurrency_amount').val(bill.RECORRENCIA_QTD);

      if (bill.RECONCILIADO != 0) {
        $('#edit_btp_expense_base_value').prop('readonly', true);
        //$('#edit_btp_expense_value').prop('readonly', true);
        $('#edit_btp_expense_discount').prop('readonly', true);
        $('#edit_btp_expense_penalty').prop('readonly', true);
        $('#edit_btp_expense_description').prop('readonly', true);
        $('#edit_btp_due_date').prop('readonly', true);
        $('#edit_btp_is_paid').prop('readonly', true);
        $('#edit_btp_paid_date').prop('readonly', true);
        $('#edit_btp_is_preview').prop('readonly', true);
      } else {
        $('#edit_btp_expense_base_value').prop('readonly', false);
        //$('#edit_btp_expense_value').prop('readonly', false);
        $('#edit_btp_expense_discount').prop('readonly', false);
        $('#edit_btp_expense_penalty').prop('readonly', false);
        $('#edit_btp_expense_description').prop('readonly', false);
        $('#edit_btp_due_date').prop('readonly', false);
        $('#edit_btp_is_paid').prop('readonly', false);
        $('#edit_btp_paid_date').prop('readonly', false);
        $('#edit_btp_is_preview').prop('readonly', false);
      }

      currentBillData = bill;
      initializeFields(true, bill)
      calculateTotal('edit');

      window.reloadMasks();

      // Load observations list
      apiCall({
        method: 'GET',
        endpoint: `api/v1/financial/bills-to-pay/observations?billId=${bill.ID}`,
        successCallback: (response) => {
          //console.log('response', response)
          let html = '';
          if (response.data && response.data.length > 0) {
            let observations = response.data;
            observations.forEach((observation) => {
              html += `<div class="card">
                <div class="card-body">
                  <h5 class="card-title text-dark">${observation.OBSERVACAO}</h5>
                  <h6 class="card-subtitle mb-2 text-muted">${observation.DATA}</h6>
                  <p class="card-text">${observation.USUARIO}</p>
                </div>
              </div>`;
            });
          } else {
            html = '<p>Nenhuma observação encontrada.</p>';
          }
          $('.js-edit-btp-observations-list').html(html);
        },
        errorCallback: (error) => {
          console.error('error', error)
        }
      });

      // Load attachments list
      apiCall({
        method: 'GET',
        endpoint: `api/v1/financial/bills-to-pay/attachments?billId=${bill.ID}`,
        successCallback: (response) => {
          //console.log('response', response)
          let html = '';
          if (response.data && response.data.length > 0) {
            let attachments = response.data;
            attachments.forEach((attachment) => {
              html += `<div class="card">
                <div class="card-body">
                  <h5 class="card-title text-dark">${attachment.ARQUIVO}</h5>
                  <h6 class="card-subtitle mb-2 text-muted">${attachment.DATA}</h6>
                  <a href="https://thequiro.clinicasajustar.com.br/view-attachment.php?filename=${attachment.ARQUIVO}&type=financial-bill-to-pay" target="_blank" class="card-link">Visualizar</a>
                </div>
              </div>`;
            });
          } else {
            html = '<p>Nenhum anexo encontrado.</p>';
          }
          $('.js-edit-btp-attachments-list').html(html);
        },
        errorCallback: (error) => {
          console.error('error', error)
        }
      });

      // Load logs list
      apiCall({
        method: 'GET',
        endpoint: `api/v1/financial/bills-to-pay/logs?billId=${bill.ID}`,
        successCallback: (response) => {
          //console.log('response', response)
          let html = '';
          if (response.data && response.data.length > 0) {
            let logs = response.data;
            logs.forEach((log) => {
              html += `<div class="card">
                <div class="card-body">
                  <h5 class="card-title text-dark">${log.ACAO}</h5>
                  <h6 class="card-subtitle mb-2 text-muted">${log.DATA}</h6>
                  <p class="card-text">${log.USUARIO}</p>
                </div>
              </div>`;
            });
          } else {
            html = '<p>Nenhum log encontrado.</p>';
          }
          $('.js-edit-btp-logs-list').html(html);
        },
        errorCallback: (error) => {
          console.error('error', error)
        }
      });
    });

    $(document).on('submit', '.js-financial-edit-bills-to-pay-new-obs-form', function(e) {
      e.preventDefault();

      let data = $(this).serializeArray();

      $('.js-financial-edit-bills-to-pay-new-obs-form').find('input[type="submit"]').prop('disabled', true);

      apiCall({
        method: 'POST',
        endpoint: 'api/v1/financial/bills-to-pay/observations/create',
        data: data,
        successCallback: (response) => {
          //console.log('response', response)
          $('.js-financial-edit-bills-to-pay-new-obs-form').find('input[type="submit"]').prop('disabled', false);
          $('.js-financial-edit-bills-to-pay-new-obs-form').trigger('reset');

          window.toast({
            error: response.error,
            text: response.message
          })

          if (!response.error) {
            $('.js-financial-edit-bills-to-pay-new-obs-form').trigger('reset');
            $('#modal-financial-edit-bills-to-pay-new-obs').modal('hide');

            // Load observations list
            apiCall({
              method: 'GET',
              endpoint: `api/v1/financial/bills-to-pay/observations?billId=${$('#edit_btp_bill_id').val()}`,
              successCallback: (response) => {
                //console.log('response', response)
                let html = '';
                if (response.data && response.data.length > 0) {
                  let observations = response.data;
                  observations.forEach((observation) => {
                    html += `<div class="card">
                      <div class="card-body">
                        <h5 class="card-title text-dark">${observation.OBSERVACAO}</h5>
                        <h6 class="card-subtitle mb-2 text-muted">${observation.DATA}</h6>
                        <p class="card-text">${observation.USUARIO}</p>
                      </div>
                    </div>`;
                  });
                } else {
                  html = '<p>Nenhuma observação encontrada.</p>';
                }
                $('.js-edit-btp-observations-list').html(html);
              },
              errorCallback: (error) => {
                console.error('error', error)
              }
            });
          }
        },
        errorCallback: (error) => {
          console.error('error', error)
          $('.js-financial-edit-bills-to-pay-new-obs-form').find('input[type="submit"]').prop('disabled', false);
        }
      });
    });

    // Seleciona a categoria financeira
    $('#edit_btp_expense_category').select2({
      placeholder: "Selecione uma categoria financeira",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-financial-bills-to-pay-edit-form-expense-category"),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/categories',
        delay: 1000,
        data: function(params) {
          var query = {
            search: params.term,
            branchId: selectedBranch.current || -1,
            page: params.page || 1,
            type: 'EXPENSE'
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function(data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.results, function(k, v) {
            results.push({
              id: v.ID,
              text: v.NOME,
              info: v
            });
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    // Detecta alteração na seleção da categoria financeira
    $('#edit_btp_expense_category').on('select2:select', function(e) {
      if (e.params) {
        financialCategoryAndCostCenterDataRef.current = e.params.data.id;
      }
    });

    // Seleciona a categoria financeira
    $('#edit_btp_expense_cost_center').select2({
      placeholder: "Selecione um centro de custo",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-financial-bills-to-pay-edit-form-expense-cost-center"),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/cost-centers',
        delay: 1000,
        data: function(params) {
          var query = {
            search: params.term,
            branchId: createSaleFormData.current.branch || -1,
            page: params.page || 1
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function(data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.results, function(k, v) {
            results.push({
              id: v.ID,
              text: `${v.CODIGO} - ${v.NOME}`,
              info: v
            });
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    // Detecta alteração na seleção do centro de custo
    $('#edit_btp_expense_cost_center').on('select2:select', function(e) {
      if (e.params) {
        financialCategoryAndCostCenterDataRef.current = e.params.data.id;
      }
    });

    // Seleciona a categoria financeira
    $('#edit_btp_expense_supplier').select2({
      placeholder: "Selecione um fornecedor",
      theme: 'bootstrap-5',
      dropdownParent: $(".js-financial-bills-to-pay-edit-form-expense-supplier"),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/suppliers',
        delay: 1000,
        data: function(params) {
          var query = {
            search: params.term,
            branchId: selectedBranch.current || -1,
            page: params.page || 1
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function(data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.data, function(k, v) {
            results.push({
              id: v.ID,
              text: v.NOME,
              info: v
            });
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    // Detecta alteração na seleção da categoria financeira
    $('#edit_btp_expense_supplier').on('select2:select', function(e) {
      if (e.params) {
        financialSupplierDataRef.current = e.params.data.id;
      }
    });

    // Detecta seleção de multiplas despesas
    $(document).on('change', '.js-financial-bills-to-pay-checkbox', function() {
      if ($(this).is(':checked')) {
        selectedBills.push($(this).data('id'));
      } else {
        selectedBills = selectedBills.filter(id => id !== $(this).data('id'));
      }
      //console.log('selectedBills', selectedBills);
      updateMultiBillSelected(selectedBills);
    });

    // Detecta alteração na data de vencimento
    $(document).on('submit', '.js-financial-edit-bills-to-pay-due-date-form', function(e) {
      e.preventDefault();

      let data = $(this).serializeArray();
      disableForm('.js-financial-edit-bills-to-pay-due-date-form');
      Swal.fire({
        title: 'Atenção',
        text: 'Tem certeza que deseja alterar a data de vencimento das despesas selecionadas?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        
      }).then((result) => {
        if (result.isConfirmed) {
          data.push({
            name: 'selectedBills',
            value: selectedBills
          });
          apiCall({
            method: 'POST',
            endpoint: 'api/v1/financial/bills-to-pay/update-due-date',
            data: data,
            successCallback: (response) => {
              //console.log('response', response);
              if (response.error) {
                window.toast({
                  error: response.error,
                  text: response.message
                })
              } else {
                selectedBills = [];
                updateMultiBillSelected(selectedBills);
                fetchBillsToPay();
              }
              enableForm('.js-financial-edit-bills-to-pay-due-date-form');
            },
            errorCallback: (error) => {
              console.error('error', error);
              enableForm('.js-financial-edit-bills-to-pay-due-date-form');
            }
          })
        } else {
          //console.log('cancelado');
          enableForm('.js-financial-edit-bills-to-pay-due-date-form');
        }
      })
    });

    // Detecta alteração na data de pagamento
    $(document).on('submit', '.js-financial-edit-bills-to-pay-paid-date-form', function(e) {
      e.preventDefault();

      let data = $(this).serializeArray();
      disableForm('.js-financial-edit-bills-to-pay-paid-date-form');
      Swal.fire({
        title: 'Atenção',
        text: 'Tem certeza que deseja alterar a data de pagamento das despesas selecionadas?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        
      }).then((result) => {
        if (result.isConfirmed) {
          data.push({
            name: 'selectedBills',
            value: selectedBills
          });
          apiCall({
            method: 'POST',
            endpoint: 'api/v1/financial/bills-to-pay/update-paid-date',
            data: data,
            successCallback: (response) => {
              //console.log('response', response);
              if (response.error) {
                window.toast({
                  error: response.error,
                  text: response.message
                })
              } else {
                selectedBills = [];
                updateMultiBillSelected(selectedBills);
                fetchBillsToPay();
              }
              enableForm('.js-financial-edit-bills-to-pay-paid-date-form');
            },
            errorCallback: (error) => {
              console.error('error', error);
              enableForm('.js-financial-edit-bills-to-pay-paid-date-form');
            }
          })
        } else {
          //console.log('cancelado');
          enableForm('.js-financial-edit-bills-to-pay-paid-date-form');
        }
      })
    });

    // detecta clique para excluir uma conta a pagar
    $(document).on('click', '.js-financial-btp-delete-bill', function() {
      let bill = $(this).data('info');
      //console.log('bill', bill);
      let selfBtn = $(this);
      $(selfBtn).prop('disabled', true);
      $(selfBtn).html('<i class="fa fa-spinner fa-spin"></i> Aguarde...');
      let thisBillData = $(this).data('info');
      Swal.fire({
        title: 'Atenção',
        text: 'Tem certeza que deseja excluir a conta a pagar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        
      }).then((result) => {
        if (result.isConfirmed) {
          if (thisBillData.RECORRENCIA_TIPO != null) {
            Swal.fire({
              title: 'ATENÇÃO!',
              text: 'Essa conta é um pagamento recorrente, deseja excluir todas parcelas futuras já lançadas pelo sistema?',
              icon: 'danger',
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Sim, excluir todas parcelas futuras.',
              cancelButtonText: 'Não, excluir apenas esta.',
            }).then((result) => {
              if (result.isConfirmed) {
                deleteBill(thisBillData.ID, selfBtn, 1);
              } else {
                deleteBill(thisBillData.ID, selfBtn, 0);
              }
            })
          } else {
            deleteBill(thisBillData.ID, selfBtn, 0);
          }
        } else {
          $(selfBtn).prop('disabled', false);
          $(selfBtn).html('<i class="fas fa-trash me-1"></i>Excluir');
        }
      })
    });

    // detecta clique para selecionar todas as checkboxes
    $(document).on('click', '.js-select-all-bills', function() {
      const checkboxes = document.querySelectorAll('.js-financial-bills-to-pay-checkbox');
      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          selectedBills = selectedBills.filter(id => id !== checkbox.value);
          checkbox.checked = false;
        } else {
          selectedBills.push(checkbox.value);
          checkbox.checked = true;
        }
      });
      //console.log('selectedBills', selectedBills);
      updateMultiBillSelected(selectedBills);
    });

    $('#modal-financial-insert-bills-to-pay').on('show.bs.modal', function() {
      initializeFields(false);
      $('.js-financial-bills-to-pay-insert-form').trigger('reset');
    });

    $('#modal-financial-insert-bills-to-pay,#modal-financial-edit-bills-to-pay').on('hidden.bs.modal', function() {
      currentBillData = false;
    });
  }

  const updateBill = (form, updateAll = false) => {
    const formElement = form instanceof HTMLFormElement ? form : $(form)[0];
    let data = new FormData(formElement);
    let selfForm = form;

    disableForm('.js-financial-bills-to-pay-edit-form');

    $('.js-financial-bills-to-pay-edit-form').find('input[type="submit"]').prop('disabled', true);
    $('.js-financial-bills-to-pay-edit-form').find('input[type="submit"]').html('<i className="fa fa-spinner fa-spin"></i> Aguarde...');
    
    data.append("edit_btp_expense_update_all_reccurrencies", (updateAll ? 1 : 0)); // processar no backend para alterar todas parcelas futuras

    apiCall({
      method: 'POST',
      endpoint: 'api/v1/financial/bills-to-pay/update',
      data: data,
      processData: false,
      contentType: false,
      successCallback: (response) => {
        //console.log('response', response)
        $(selfForm).find('input[type="submit"]').prop('disabled', false);
        $(selfForm).find('input[type="submit"]').html('Atualizar');
        enableForm('.js-financial-bills-to-pay-edit-form');
        window.toast({
          error: response.error,
          text: response.message
        })

        if (!response.error) {
          fetchBillsToPay();

          // reset file field
          $('#edit_btp_file').val(null);

          // Load observations list
          apiCall({
            method: 'GET',
            endpoint: `api/v1/financial/bills-to-pay/observations?billId=${$('#edit_btp_bill_id').val()}`,
            successCallback: (response) => {
              //console.log('response', response)
              let html = '';
              if (response.data && response.data.length > 0) {
                let observations = response.data;
                observations.forEach((observation) => {
                  html += `<div class="card">
                    <div class="card-body">
                      <h5 class="card-title text-dark">${observation.OBSERVACAO}</h5>
                      <h6 class="card-subtitle mb-2 text-muted">${observation.DATA}</h6>
                      <p class="card-text">${observation.USUARIO}</p>
                    </div>
                  </div>`;
                });
              } else {
                html = '<p>Nenhuma observação encontrada.</p>';
              }
              $('.js-edit-btp-observations-list').html(html);
            },
            errorCallback: (error) => {
              console.error('error', error)
            }
          });

          // Load attachments list
          apiCall({
            method: 'GET',
            endpoint: `api/v1/financial/bills-to-pay/attachments?billId=${$('#edit_btp_bill_id').val()}`,
            successCallback: (response) => {
              //console.log('response', response)
              let html = '';
              if (response.data && response.data.length > 0) {
                let attachments = response.data;
                attachments.forEach((attachment) => {
                  html += `<div class="card">
                    <div class="card-body">
                      <h5 class="card-title text-dark">${attachment.ARQUIVO}</h5>
                      <h6 class="card-subtitle mb-2 text-muted">${attachment.DATA}</h6>
                      <a href="https://thequiro.clinicasajustar.com.br/view-attachment.php?filename=${anexo}&type=financial-bill-to-pay" target="_blank" class="card-link">Visualizar</a>
                    </div>
                  </div>`;
                });
              } else {
                html = '<p>Nenhum anexo encontrado.</p>';
              }
              $('.js-edit-btp-attachments-list').html(html);
            },
            errorCallback: (error) => {
              console.error('error', error)
            }
          });

          // Load logs list
          apiCall({
            method: 'GET',
            endpoint: `api/v1/financial/bills-to-pay/logs?billId=${$('#edit_btp_bill_id').val()}`,
            successCallback: (response) => {
              //console.log('response', response)
              let html = '';
              if (response.data && response.data.length > 0) {
                let logs = response.data;
                logs.forEach((log) => {
                  html += `<div class="card">
                    <div class="card-body">
                      <h5 class="card-title text-dark">${log.ACAO}</h5>
                      <h6 class="card-subtitle mb-2 text-muted">${log.DATA}</h6>
                      <p class="card-text">${log.USUARIO}</p>
                    </div>
                  </div>`;
                });
              } else {
                html = '<p>Nenhum log encontrado.</p>';
              }
              $('.js-edit-btp-logs-list').html(html);
            },
            errorCallback: (error) => {
              console.error('error', error)
            }
          });
        }
      },
      errorCallback: (error) => {
        console.error('error', error)
        enableForm('.js-financial-bills-to-pay-edit-form');
        $(selfForm).find('input[type="submit"]').prop('disabled', false);
        $(selfForm).find('input[type="submit"]').html('Atualizar');
      }
    });
  }
  
  const deleteBill = (billId, selfBtn, deleteAllInFuture = 0) => {
    apiCall({
      method: 'DELETE',
      endpoint: `api/v1/financial/bills-to-pay/delete?billId=${billId}&deleteAllInFuture=${deleteAllInFuture}`,
      successCallback: (response) => {
        //console.log('response', response);
        if (response.error) {
          window.toast({
            error: response.error,
            text: response.message
          })
          $(selfBtn).prop('disabled', false);
          $(selfBtn).html('<i class="fas fa-trash me-1"></i>Excluir');
        } else {
          fetchBillsToPay();
        }
      },
      errorCallback: (error) => {
        console.error('error', error);
        $(selfBtn).prop('disabled', false);
        $(selfBtn).html('<i class="fas fa-trash me-1"></i>Excluir');
      }
    })
  }

  const deleteBills = (bills) => {
    Swal.fire({
      title: 'Atenção',
      text: 'Tem certeza que deseja excluir os pagamentos selecionados?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    }).then((result) => {
      if (result.isConfirmed) {
        let data = [];
        data.push({
          name: 'selectedBills',
          value: selectedBills
        });
        apiCall({
          method: 'DELETE',
          endpoint: 'api/v1/financial/bills-to-pay/delete-multiple',
          data: data,
          successCallback: (response) => {
            //console.log('response', response);
            if (response.error) {
              window.toast({
                error: response.error,
                text: response.message
              })
            } else {
              selectedBills = [];
              updateMultiBillSelected(selectedBills);
              fetchBillsToPay();
            }
          },
          errorCallback: (error) => {
            console.error('error', error);
          }
        })
      }
    })
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);
  }, []);

  const fetchBillsToPay = (startDueDate = null, endDueDate = null, startPaymentDate = null, endPaymentDate = null, status = null) => {

    /*console.log('fetchBillsToPay', 'startDueDate', startDueDate);
    console.log('fetchBillsToPay', 'endDueDate', endDueDate);
    console.log('fetchBillsToPay', 'startPaymentDate', startPaymentDate);
    console.log('fetchBillsToPay', 'endPaymentDate', endPaymentDate);*/

    if (startDueDate !== null && endDueDate !== null) {
      filterData.current = {
        startDate: startDueDate,
        endDate: endDueDate
      }
    }

    if (startPaymentDate !== null && endPaymentDate !== null) {
      paymentDateFilter.current = {
        paymentDateStartDate: startPaymentDate,
        paymentDateEndDate: endPaymentDate
      }
    }

    $('#insert_btp_branch_id').val(selectedBranch.current);
    $('#edit_btp_branch_id').val(selectedBranch.current);

    countTotalBillsPaymentPaid.current = 0;
    countBillsPaid.current = 0;
    countTotalBillsPaymentOpen.current = 0;
    countBillsOpen.current = 0;
    countTotalBillsPaymentLate.current = 0;
    countBillsLate.current = 0;
    countTotalBillsPaymentPrevision.current = 0;
    countBillsPrevision.current = 0;

    //console.log('fetchBillsToPay', 'filterData', filterData);
    //console.log('fetchBillsToPay', 'paymentDateFilter', paymentDateFilter);

    $('#js-financial-bills-to-pay-list').html(`
      <div class="w-100 d-flex justify-content-center align-items-center mt-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>`);

    if (currentXhr.current != null) {
      currentXhr.current.abort();
      currentXhr.current = null;
    }

    currentXhr.current = apiCall({
      method: 'GET',
      endpoint: `api/v1/financial/bills-to-pay?branchId=${selectedBranch.current}&startDate=${startDueDate ? startDueDate : filterData.current.startDate}&endDate=${endDueDate ? endDueDate : filterData.current.endDate}&search=${$('.js-financial-bills-to-pay-search').val()}&allPeriod=${$('.js-financial-bills-to-pay-all-periods').is(':checked') ? 1 : 0}&status=${statusFilter}&paymentDateStartDate=${$('#filter_by_payment_date').is(':checked') ? paymentDateFilter.current.paymentDateStartDate : (status == 'paid' ? (startDueDate ? startDueDate : filterData.current.startDate) : null)}&paymentDateEndDate=${$('#filter_by_payment_date').is(':checked') ? paymentDateFilter.current.paymentDateEndDate : (status == 'paid' ? (endDueDate ? endDueDate : filterData.current.endDate) : null)}&status=${status ? status : statusFilter}`,
      successCallback: (response) => {
        //console.log('response', response)

        let html = '';
        if (response.data && response.data.length > 0) {
          let billsToPay = response.data;
          setBills({
            countTotalBillsPaymentOpen: response.data_amount.open,
            countBillsOpen: response.data_count.open,
            countTotalBillsPaymentPaid: response.data_amount.paid,
            countBillsPaid: response.data_count.paid,
            countTotalBillsPaymentLate: response.data_amount.late,
            countBillsLate: response.data_count.late,
            countTotalBillsPaymentPrevision: response.data_amount.prevision,
            countBillsPrevision: response.data_count.prevision
          });
          renderBills(response.data);
        } else {
          setBills({
            countTotalBillsPaymentOpen: 0,
            countBillsOpen: 0,
            countTotalBillsPaymentPaid: 0,
            countBillsPaid: 0,
            countTotalBillsPaymentLate: 0,
            countBillsLate: 0,
            countTotalBillsPaymentPrevision: 0,
            countBillsPrevision: 0
          });
          setBillsData([]);
          html = '<p>Nenhuma conta a pagar encontrada.</p>';
          $('#js-financial-bills-to-pay-list').html(html);
          //$('#js-financial-bills-to-pay-list').unblock();
        }
      },
      errorCallback: (error) => {
        setBills({
          countTotalBillsPaymentOpen: 0,
          countBillsOpen: 0,
          countTotalBillsPaymentPaid: 0,
          countBillsPaid: 0,
          countTotalBillsPaymentLate: 0,
          countBillsLate: 0,
          countTotalBillsPaymentPrevision: 0,
          countBillsPrevision: 0
        });
        setBillsData([]);
        //$('#js-financial-bills-to-pay-list').block(window._loader.error);
        console.error('error', error)
      }
    })
  }

  const renderBills = (bills, status) => {
    if (bills?.length > 0) {
      setBillsData(bills);
    }
    if (status) {
      setStatusFilter(status);
    }
    let html = '';
    
    countTotalBillsPaymentPaid.current = 0;
    countBillsPaid.current = 0;
    countTotalBillsPaymentOpen.current = 0;
    countBillsOpen.current = 0;
    countTotalBillsPaymentLate.current = 0;
    countBillsLate.current = 0;
    countTotalBillsPaymentPrevision.current = 0;
    countBillsPrevision.current = 0;

    const billsToFilter = bills ? bills : billsData;
    const filteredBills = bills;

    // sum valor_conciliado in filteredBills
    const sumValorConciliado = filteredBills.reduce((acc, bill) => acc + parseFloat(Math.abs(bill.VALOR_CONCILIADO)), 0);
    console.log('sumValorConciliado', sumValorConciliado);

    billsToFilter.forEach((bill) => {
      let tipoRecorrencia = null;
      switch(bill.RECORRENCIA_TIPO) {
        case 'D': tipoRecorrencia = 'Diária'; break;
        case 'W': tipoRecorrencia = 'Semanal'; break;
        case 'M': tipoRecorrencia = 'Mensal'; break;
      }

      html += `
      <div class="row align-items-center py-2 border-bottom g-3">
          <!-- Checkbox e Descrição -->
          <div class="col-md-4">
            <div class="d-flex align-items-center gap-2">
              <div class="form-check">
                <input type="checkbox" class="form-check-input js-financial-bills-to-pay-checkbox" value="${bill.ID}" data-id="${bill.ID}">
              </div>
              <div>
                ${bill.RECORRENCIA_TIPO !== null ? 
                    `<span class="badge bg-info me-2">
                        <i class="fas fa-retweet me-1"></i>${bill.RECORRENCIA_PARCELA}/${bill.RECORRENCIA_QTD}
                    </span>` : 
                    ''
                }
                <span class="text-truncate"><small>#${bill.ID}</small> ${bill.DESCRICAO == null ? 'Sem descrição' : bill.DESCRICAO}</span>
                ${bill.CATEGORIA !== null || bill.CENTRO_CUSTO !== null ? 
                    `<div class="mt-1">
                        <small class="badge bg-secondary">
                            ${bill.CATEGORIA !== null ? bill.CATEGORIA : ''}
                            ${bill.CENTRO_CUSTO !== null ? ` - ${bill.CENTRO_CUSTO}` : ''}
                        </small>
                    </div>` : 
                    ''
                }
                <!-- Valor -->
                <div class="mt-2">
                  <span class="fw-bold text-danger">
                    R$ ${bill.VALOR}
                    ${bill.VALOR_PAGAMENTO_PARCIAL != null ? `<br />Total pago: R$ ${bill.VALOR_PAGAMENTO_PARCIAL}<br/ >Total restante: R$ ${bill.VALOR - bill.VALOR_PAGAMENTO_PARCIAL}` : ''}
                  </span>
                </div>
              </div>
            </div>
 
          </div>
  
          <!-- Data -->
          <div class="col-md-2 text-center">
              <small class="text-muted d-block">Vencimento</small>
              ${moment(bill.DATA_VENCIMENTO).format('DD/MM/YYYY')}
          </div>

          <!-- Data de pagamento -->
          <div class="col-md-2 text-center">
              <small class="text-muted d-block">${bill.DATA_MOVIMENTACAO ? 'Data em que foi pago' : 'Prev. Pagamento'}</small>
              ${bill.DATA_MOVIMENTACAO ? moment(bill.DATA_MOVIMENTACAO).format('DD/MM/YYYY') : (bill.DATA_PAGAMENTO == null ? 'Não pago' : moment(bill.DATA_PAGAMENTO).format('DD/MM/YYYY'))}
          </div>
  
          <!-- Status -->
          <div class="col-md-2 text-center">
              ${bill.PAGO == 'S' && bill.RECONCILIADO == 0 ? 
                  `<span class="badge bg-success">
                      <i class="fas fa-check-circle me-1"></i>Pago ${moment(bill.DATA_PAGAMENTO).format('DD/MM')}
                  </span>` : 
                  bill.RECONCILIADO != 0 ? 
                      `<span class="badge bg-success" data-tippy-content="Conciliado com a movimentação #${bill.RECONCILIADO} da data ${moment(bill.DATA_MOVIMENTACAO).format('DD/MM')} por ${bill.CONCILIADO_POR} - DESCRICAO EXTRATO: ${bill.DESCRICAO_MOVIMENTACAO}">
                        <i class="fas fa-check-circle me-1"></i>Conciliado ${bill.VALOR_PAGAMENTO_PARCIAL != null ? `parcialmente` : ''}
                      </span>` :
                      `<span class="badge ${bill.DATA_VENCIMENTO < moment().format('YYYY-MM-DD') ? 'bg-danger' : 'bg-warning'}">
                        <i class="fas fa-exclamation-circle me-1"></i>
                        ${bill.DATA_VENCIMENTO < moment().format('YYYY-MM-DD') ? 'Vencida' : 'Pendente'}
                      </span>`
              }
          </div>
  
          <!-- Ações -->
          <div class="col-md-1 text-end">
              <button class="btn btn-sm btn-outline-primary js-financial-btp-view-bill" 
                  data-bs-toggle="modal" 
                  data-bs-target="#modal-financial-edit-bills-to-pay" 
                  data-info='${JSON.stringify(bill)}'>
                  <i class="fas fa-edit"></i>
              </button>
              ${bill.RECONCILIADO == 0 ? 
                  `<button class="btn btn-sm btn-outline-danger js-financial-btp-delete-bill" 
                      data-info='${JSON.stringify(bill)}'>
                      <i class="fas fa-trash"></i>
                  </button>` : 
                  ''
              }
          </div>
      </div>`;
    });

    $('#js-financial-bills-to-pay-list').html(html);
    $('#js-financial-bills-to-pay-list').unblock();

    window.reloadIconss();
  }

  const updateMultiBillSelected = (selectedBills) => {
    setMultiBillSelectedData(selectedBills);
    //console.log('updateMultiBillSelected', selectedBills);
  }

  const handleStatusFilter = (status) => {
    //console.log('status', status)
    //console.log('statusFilter', statusFilter)
    let newState = status;
    if (status == statusFilter) {
      newState = 'all';
    }
    setStatusFilter(newState);
    fetchBillsToPay(null, null, null, null, newState);
  }

  const exportToPDF = () => {
    const doc = new jsPDF('landscape');
    
    // Adiciona o cabeçalho
    doc.setFontSize(16);
    doc.text('Relatório de Contas a Pagar', 14, 15);
    
    // Adiciona o período
    doc.setFontSize(10);
    doc.text(`Período: ${moment(filterData.current.startDate).format('DD/MM/YYYY')} a ${moment(filterData.current.endDate).format('DD/MM/YYYY')}`, 14, 25);
    
    // Informações da empresa
    doc.text(`${branches.find(b => b.ID == branch)?.FILIAL || ''}`, 14, 30);
    
    // Totalizadores
    doc.text(`Vencidos (R$): ${float2moeda(bills.countTotalBillsPaymentLate)}`, 180, 25);
    doc.text(`Vencem hoje (R$): ${float2moeda(bills.countTotalBillsPaymentOpen+bills.countTotalBillsPaymentLate)}`, 180, 30);
    doc.text(`A vencer (R$): ${float2moeda(bills.countTotalBillsPaymentPrevision)}`, 180, 35);
    doc.text(`Pagos (R$): ${float2moeda(bills.countTotalBillsPaymentPaid)}`, 180, 40);
    doc.text(`Total do Período (R$): ${float2moeda(bills.countTotalBillsPaymentOpen + bills.countTotalBillsPaymentPaid + bills.countTotalBillsPaymentLate)}`, 180, 45);

    // Configuração da tabela
    const tableColumn = [
      'ID',
      'Vencimento',
      'Pagamento',
      'Descrição',
      'Fornecedor',
      'Categoria',
      'Valor total (R$)',
      'A pagar (R$)',
      'Situação'
    ];

    // Dados da tabela
    const tableRows = billsData.map(bill => [
      bill.ID,
      moment(bill.DATA_VENCIMENTO).format('DD/MM/YYYY'),
      bill.DATA_PAGAMENTO ? moment(bill.DATA_PAGAMENTO).format('DD/MM/YYYY') : '-',
      bill.DESCRICAO || 'Sem descrição',
      bill.FORNECEDOR || '-',
      bill.CATEGORIA || '-',
      float2moeda(bill.VALOR),
      bill.PAGO === 'N' ? float2moeda(bill.VALOR) : '0,00',
      bill.PAGO === 'S' ? 'Pago' : bill.DATA_VENCIMENTO < moment().format('YYYY-MM-DD') ? 'Em atraso' : 'Em aberto'
    ]);

    // Gera a tabela
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 50,
      styles: {
        fontSize: 8,
        cellPadding: 2
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    // Adiciona rodapé
    const pageCount = doc.internal.getNumberOfPages();
    for(let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(`Página ${i} de ${pageCount}`, doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 10);
      doc.text(`Gerado em: ${moment().format('DD/MM/YYYY HH:mm:ss')}`, 14, doc.internal.pageSize.height - 10);
    }

    // Salva o PDF
    doc.save(`contas-a-pagar-${moment().format('DDMMYYYY-HHmmss')}.pdf`);
  };

  window.fetchBillsToPay = fetchBillsToPay;

  return (
    <>
      {branch === null ? <p>Selecione uma filial e um período para visualizar as contas a pagar.</p> : (
        <>
          <div className="d-flex gap-2 mb-3">
            <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modal-financial-insert-bills-to-pay">
              Cadastrar nova conta
            </button>
            {billsData.length > 0 && (
              <button className="btn btn-secondary" onClick={exportToPDF}>
                <i className="fas fa-print me-2"></i>
                Imprimir Relatório
              </button>
            )}
          </div>
          <div className="p-relative">
            <div className="w-100 rounded-top bg-white shadow-sm" style={{position: 'sticky', bottom: '-2rem'}}>
              <div className="row g-0">
                <div className="col-sm-12 col-md-3 p-3 border-end">
                  <div className={`d-flex flex-column ml-2 justify-content-center js-financial-bills-status-filter ${statusFilter === 'open' ? 'border-bottom' : ''}`} data-status="open" onClick={() => handleStatusFilter('open')}>
                    <span className="text-muted small text-uppercase">Em aberto <i className="fas fa-info-circle" data-tippy-content="Contas que ainda não venceram"></i></span>
                    <h4 className="my-2 fw-bold text-primary">R$ {float2moeda(bills.countTotalBillsPaymentOpen)}</h4>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-primary rounded-pill me-2">{bills.countBillsOpen}</span>
                      <span className="small text-muted">contas pendentes</span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-3 p-3 border-end">
                  <div className={`d-flex flex-column ml-2 justify-content-center js-financial-bills-status-filter ${statusFilter === 'paid' ? 'border-bottom' : ''}`} data-status="paid" onClick={() => handleStatusFilter('paid')}>
                    <span className="text-muted small text-uppercase">
                      {statusFilter !== 'paid' ? `Foi pago e venceria neste período` : `A movimentação bancária ocorreu neste período`} <i className="fas fa-info-circle" data-tippy-content={statusFilter === 'paid' ? `A movimentação bancária ocorreu neste período, clique para ver o que venceu neste período` : `Foi pago e venceria neste período, clique para ver o que foi movimentado no período`}></i>
                    </span>
                    <h4 className="my-2 fw-bold text-success">R$ {float2moeda(bills.countTotalBillsPaymentPaid)}</h4>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-success rounded-pill me-2">{bills.countBillsPaid}</span>
                      <span className="small text-muted">contas quitadas</span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-3 p-3 border-end">
                  <div className={`d-flex flex-column ml-2 justify-content-center js-financial-bills-status-filter ${statusFilter === 'late' ? 'border-bottom' : ''}`} data-status="late" onClick={() => handleStatusFilter('late')}>
                    <span className="text-muted small text-uppercase">Em atraso <i className="fas fa-info-circle" data-tippy-content="Contas que venceram e ainda não foram pagas"></i></span>
                    <h4 className="my-2 fw-bold text-danger">R$ {float2moeda(bills.countTotalBillsPaymentLate)}</h4>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-danger rounded-pill me-2">{bills.countBillsLate}</span>
                      <span className="small text-muted">contas atrasadas</span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-3 p-3">
                  <div className={`d-flex flex-column ml-2 justify-content-center js-financial-bills-status-filter ${statusFilter === 'prevision' ? 'border-bottom' : ''}`} data-status="prevision" onClick={() => handleStatusFilter('prevision')}>
                    <span className="text-muted small text-uppercase">Previsto <i className="fas fa-info-circle" data-tippy-content="Contas que vencerão em um período futuro"></i></span>
                    <h4 className="my-2 fw-bold text-info">R$ {float2moeda(bills.countTotalBillsPaymentPrevision)}</h4>
                    <div className="d-flex align-items-center">
                      <span className="badge bg-info rounded-pill me-2">{bills.countBillsPrevision}</span>
                      <span className="small text-muted">contas futuras</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="js-financial-bills-to-pay-list" className='mb-5' style={{maxHeight:'650px', overflow:'auto'}}>
              <div className="w-100 d-flex justify-content-center align-items-center mt-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
              </div>
            </div>
            {/*botao para selecionar todas as checkboxes*/}
            <button className="btn btn-sm btn-outline-primary js-select-all-bills">Selecionar todas</button>
            {multiBillSelectedData.length > 0 && (
              <div className="position-absolute bottom-2 d-flex justify-content-center w-100 p-3 bg-white" style={{maxHeight: '650px', bottom: '1em'}}>
                <button className="btn btn-sm btn-outline-primary" data-bs-toggle="dropdown">
                    <i className="fas fa-cogs"></i> Ações em lote
                </button>
                <div className="dropdown-menu">
                  <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#modal-financial-edit-bills-to-pay-due-date">
                    <i className="fas fa-check-circle"></i> Alterar data de vencimento
                  </button>
                  <button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#modal-financial-edit-bills-to-pay-paid-date">
                    <i className="fas fa-check-circle"></i> Alterar de pagamento
                  </button>
                  <button className="dropdown-item" onClick={() => {
                    deleteBills();
                  }}>
                    <i className="fas fa-trash"></i> Excluir pagamentos
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="divider"></div>
          {branch} - {filterData.startDate} - {filterData.endDate}
        </>  
      )}
    </>
  )
};

try {
  if (document.getElementById('js-financial-bills-to-pay-content')) {
    const container = document.getElementById('js-financial-bills-to-pay-content');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<BillsToPay />);
  }
} catch(err) {
  console.error('Error rendering BillsToPay: ', err);
}